export type JSPrimitive = null | undefined | boolean | number | string | symbol;

/**
 * Return a string name for the type of a value.
 */
export function typeNameOf(value: any): string {
    if (value === null) {
        return 'null';
    }
    if (value === undefined) {
        return 'undefined';
    }
    if (typeof value === 'boolean' || typeof value === 'number' || typeof value === 'string') {
        return typeof value;
    }
    if (value.constructor) {
        return value.constructor.name;
    }

    return 'unknown';
}

/**
 * Test if a value is a primitive.
 */
export function isPrimitive(value: any): value is JSPrimitive {
    return (
        value === null ||
        value === undefined ||
        typeof value === 'boolean' ||
        typeof value === 'number' ||
        typeof value === 'string' ||
        typeof value === 'symbol'
    );
}

/**
 * Determine whether the given `input` is iterable.
 */
export function isIterable(input: any): input is Iterable<any> {
    if (input === null || input === undefined) {
        return false;
    }

    return typeof input[Symbol.iterator] === 'function';
}

const defaultValueOf = () => Object.prototype.valueOf();

/**
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/valueOf
 */
export function _valueOf(obj: any): any {
    return obj.valueOf !== defaultValueOf() && typeof obj.valueOf === 'function'
        ? obj.valueOf(obj)
        : obj;
}
